module.exports = __webpack_public_path__ + "static/img/obj2.185c6b39.png";